import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { setSlikePreviewID } from 'reduxUtils/modules/common';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import Video from 'components/Video/VideoLoader';
import throttle from 'lodash.throttle';
import { inViewForReact } from 'utils/common';
import makeRequest from 'utils/makeRequest';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import Card from 'components_v2/common/CardV2';
import Link from '../../../components/Link';
import { openVideoModal } from '../VideoModal/redux';
import s from './InlineVideos.scss';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';
import NewStoryMobileCard from './../../../components_v2/mobile/NewStoryCard';

class InlineVideos extends React.Component {
  constructor() {
    super();
    this.state = {
      leadVideoPlayInitiated: false,
      csrData: undefined,
    };
  }
  componentDidMount() {
    if (this.props.autoPlayLeadVideo) {
      this.throttledScrollEvent = throttle(this.playVideoInView, 100);
      window.addEventListener('scroll', this.throttledScrollEvent);
    }
  }
  handleVideoClick(event, item, index) {
    event.preventDefault();

    const {
      gaAction,
      gaCategory,
      fromEtimesAS,
      fromEtimesPS,
      gaLabelSuffix,
      gaLabelPrefix,
      gaFunction,
      ga4Type,
    } = this.props;
    let { gaLabel } = this.props;
    const isGaFunction = gaFunction && typeof gaFunction === 'function';
    if (isGaFunction) {
      gaFunction(item, index);
    }
    if (fromEtimesPS) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: ga4Type || 'photostories_widget',
        category: 'story_click',
        story_no: index + 1,
      });
    }
    if (gaLabelSuffix && gaLabelPrefix && gaAction && !isGaFunction) {
      gaLabel = `${gaLabelPrefix}_${index}_${gaLabelSuffix}`;
      sendGaThroughProps({
        data: {
          gaAction,
          gaLabel,
        },
      });
    } else if (gaAction && gaCategory && gaLabel) {
      sendGaThroughProps({
        data: {
          gaCategory,
          gaAction,
          gaLabel: `${gaLabel}-${index}`,
        },
      });
    } else if (gaAction && !(gaCategory && gaLabel)) {
      if (fromEtimesAS) {
        sendGaThroughProps({
          data: {
            gaAction,
            gaLabel: `${index}-${item.wu}`,
          },
        });
      } else {
        sendGaThroughProps({
          data: {
            gaAction: `${gaAction}-${index}`,
            gaLabel: `${item.wu}`,
          },
        });
      }
    }
    if (ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: `${ga4Type}`,
        category: 'story_click',
        label: 'videoshow',
        story_no: `${index + 1}`,
        msid: item?.id,
      });
    }
    if (item.tn === 'photostory' || item.tn !== 'video') {
      window.location.href = item.wu;
      return;
    }
    if (this.props.openVideoLink) {
      window.location.href = item.wu;
      return;
    }
    if (typeof this.props.openVideoModalFromProps === 'function') {
      this.props.openVideoModalFromProps({
        videoItem: item,
        source: this.props.source || 'USNHP',
        isVideoSkipAds: this.props.isVideoSkipAds,
        path:
          this.props.sectionData && this.props.sectionData.path
            ? this.props.sectionData.path
            : undefined,
      });
    }
  }

  componentWillUnmount() {
    this.removeScrollEvent();
  }
  removeScrollEvent = () => {
    if (this.props.autoPlayLeadVideo) {
      window.removeEventListener('scroll', this.throttledScrollEvent);
    }
  };

  isElementEdgesVisible = el => {
    if (el && inViewForReact(el, 0, true)) {
      return true;
    }
    return false;
  };

  playVideoInView = () => {
    if (!this.videoElem) {
      const { sectionData } = this.props;
      const data = sectionData.data || sectionData.items;
      if (Array.isArray(data) && data.length && data[0] && data[0].id) {
        this.videoElem = document.querySelector(
          `[data-videomsid="${data[0].id}"]`,
        );
      }
    }

    if (this.videoElem && this.isElementEdgesVisible(this.videoElem)) {
      this.setState({ leadVideoPlayInitiated: true });
      window.removeEventListener('scroll', this.throttledScrollEvent);
    }
  };

  loadData = () => {
    const { sectionData } = this.props;
    if (sectionData && sectionData.dataUrl) {
      makeRequest
        .get(sectionData.dataUrl)
        .then(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            Array.isArray(response.data.items)
          ) {
            this.setState({
              csrData: response.data.items,
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  // Ga4 widget view call
  ga4ViewElement = (ga4Type, ga4Category) => {
    if (ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: `${ga4Type}`,
        category: `${ga4Category || ''}`,
      });
    }
  };

  render() {
    const {
      sectionData,
      theme = {},
      wrapperClass,
      isClientSide,
      useImageV2,
      borderClass,
      ga4Type,
      ga4Category,
      setSlikePreviewId,
      hoveredSlikeId,
      hoveredSlikeIndex,
    } = this.props;
    const data =
      (sectionData && (sectionData.data || sectionData.items)) ||
      this.state.csrData;
    // const { moreText, moreLink } = this.props;

    const parentClassName = classNames({
      [s.photoGalWidget]: sectionData.className === 'photoGalWidget',
      [s.photoGalWidgetBottom]:
        sectionData.className === 'photoGalWidgetBottom',
      [s.trending_stories]: sectionData.id === 'Featured_Widget',
    });

    const setSlikePreview = (msid, gaIndex) => {
      setSlikePreviewId(msid, gaIndex);
    };

    let component =
      data && data instanceof Array ? (
        <div
          className={`${s.col2} ${wrapperClass} ${s[theme]} ${
            sectionData.className === 'topvideos' ||
            sectionData.name === 'top videos' ||
            sectionData.name === 'cryptocurrency videos' ||
            sectionData.name === 'Latest Business Videos' ||
            sectionData.name === 'Explore Photos & Videos' ||
            this.props.isHeadingShown
              ? s.topvdos
              : ''
          } ${parentClassName}`}
          data-scrollga={this.props.onScrollGA}
        >
          {sectionData.name && (
            <div className={s.heading}>
              {sectionData.name}
              {sectionData.path && (
                <div className={s.Morelink}>
                  <Link
                    to={sectionData.path}
                    data-ga={`click-${sectionData.name.replace(
                      / /g,
                      '',
                    )}-more|${sectionData.path}`}
                    ga4Data={
                      ga4Type && [
                        {
                          event: 'user_click',
                          type: `${ga4Type}`,
                          label: `${sectionData.name.toLowerCase()}`,
                          category: `${'section_heading_click' || ga4Category}`,
                        },
                      ]
                    }
                  >
                    More
                  </Link>
                </div>
              )}
            </div>
          )}

          <div
            className={`${
              sectionData.tn === 'photoslider' ? s.photowrapper : s.videoWrapper
            }`}
          >
            {data.map((cardItem, index) => (
              <React.Fragment key={cardItem.id}>
                {index === 0 &&
                this.props.autoPlayLeadVideo &&
                this.state.leadVideoPlayInitiated ? (
                  <figure
                    className={s.autoplaywrapper}
                    onClick={event => {
                      this.handleVideoClick(event, cardItem, index);
                    }}
                  >
                    <Video
                      autoPlayLeadVideo={this.props.autoPlayLeadVideo}
                      msid={cardItem.id}
                      videoClassName={s.autoplayvdo}
                      videoClassInner={s.content}
                      autoplay
                      isInline
                      hideControls
                      source={this.props.source || 'InlineVideoWidget'}
                      isMute
                      isVideoSkipAds={this.props.isVideoSkipAds}
                      tmplSource="videoshow"
                    />
                    <figcaption>
                      <Link to={cardItem.wu}>{cardItem.hl}</Link>
                    </figcaption>
                  </figure>
                ) : (
                  // <Card
                  //   isMobileInlineVideo={cardItem.tn === 'video'}
                  //   isVerticalTile
                  //   data={cardItem}
                  //   imgWidth="240"
                  //   useImageV2={useImageV2}
                  //   cssObj={{
                  //     imgCont: s[theme],
                  //     titleCont: s[theme],
                  //   }}
                  //   onClick={event => {
                  //     this.handleVideoClick(event, cardItem, index);
                  //   }}
                  //   useContentVisibilty={this.props.useContentVisibilty}
                  //   slikeId={cardItem?.playerId}
                  //   gaIndex={index + 1}
                  //   hoveredSlikeId={hoveredSlikeId}
                  //   hoveredSlikeIndex={hoveredSlikeIndex}
                  //   setSlikePreviewId={setSlikePreview}
                  // />
                  <div className={s.videoCardSlideWrap}>
                    <NewStoryMobileCard
                      title={cardItem.hl || ''}
                      msid={cardItem.imageid || ''}
                      isBigHeading
                      key={cardItem.imageid || cardItem.hl}
                      isLarge={false}
                      cardType="card_23"
                      videoTime={cardItem?.du}
                      slikeId={cardItem?.playerId}
                      iconClass="videoshowIcon"
                      createdTime={cardItem?.createdTime}
                      gaIndex={index + 1}
                      ga4Type={cardItem?.ga4Type}
                      ga4Label={cardItem?.ga4Type}
                      wu={cardItem?.wu}
                    />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      ) : null;

    if (this.props.border && this.props.border === 'top' && component) {
      component = (
        <div className={`${s.border_top} ${borderClass ? s[borderClass] : ''}`}>
          {component}
        </div>
      );
    }

    return isClientSide ? (
      <InViewObserver
        inViewCallback={() => {
          this.loadData();
          // this.ga4ViewElement(ga4Type, ga4Category);
        }}
        viewMargin="900px 0px 900px 0px"
        id={sectionData && sectionData.jumplinkId}
      >
        {component}
      </InViewObserver>
    ) : (
      <InViewObserver
        // inViewCallback={() => {
        //   this.ga4ViewElement(ga4Type, ga4Category);
        // }}
        id={sectionData && sectionData.jumplinkId}
      >
        {component}
      </InViewObserver>
    );
  }
}
InlineVideos.propTypes = {
  sectionData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    path: PropTypes.string,
    data: PropTypes.shape({}),
    items: PropTypes.shape({}),
    dataUrl: PropTypes.string,
    className: PropTypes.string,
    tn: PropTypes.string,
  }).isRequired,
  openVideoModalFromProps: PropTypes.func.isRequired,
  theme: PropTypes.string,
  autoPlayLeadVideo: PropTypes.bool,
  source: PropTypes.string,
  className: PropTypes.string,
  gaAction: PropTypes.string,
  gaLabel: PropTypes.string,
  gaCategory: PropTypes.string,
  useContentVisibilty: PropTypes.bool,
  wrapperClass: PropTypes.string,
  onScrollGA: PropTypes.string,
  openVideoLink: PropTypes.bool,
  border: PropTypes.string,
  isClientSide: PropTypes.bool,
  isHeadingShown: PropTypes.bool,
  fromEtimesAS: PropTypes.bool,
  gaLabelPrefix: PropTypes.string,
  gaLabelSuffix: PropTypes.string,
  useImageV2: PropTypes.bool,
  isVideoSkipAds: PropTypes.bool,
  gaFunction: PropTypes.func,
  ga4Type: PropTypes.string,
  ga4Category: PropTypes.string,
};
InlineVideos.defaultProps = {
  theme: '',
  wrapperClass: '',
  className: '',
  autoPlayLeadVideo: false,
  source: '',
  gaAction: '',
  gaLabel: undefined,
  gaCategory: undefined,
  useContentVisibilty: false,
  onScrollGA: '',
  openVideoLink: false,
  border: undefined,
  isClientSide: false,
  isHeadingShown: false,
  fromEtimesAS: false,
  gaLabelPrefix: '',
  gaLabelSuffix: '',
  useImageV2: false,
  isVideoSkipAds: false,
  gaFunction: undefined,
  ga4Type: '',
  ga4Category: '',
};

const mapDispatchToProps = dispatch => ({
  openVideoModalFromProps: params => {
    dispatch(openVideoModal(params));
  },
  setSlikePreviewId: (slikeId, index) => {
    dispatch(setSlikePreviewID(slikeId, index));
  },
});
const mapStateToProps = state => ({
  hoveredSlikeId: state?.common?.slikePreview?.slikeId,
  hoveredSlikeIndex: state?.common?.slikePreview?.index,
});

export default connect(mapStateToProps, mapDispatchToProps)(InlineVideos);
